import React from "react";
import { Link } from "react-router-dom";

const ReadyToPlan = () => {
  return (
    <section className="py-5" style={{ backgroundColor: "var(--light-bg)" }}>
      <div className="container">
        <div className="card shadow-lg mx-auto" style={{ maxWidth: "700px", borderRadius: "1rem" }}>
          <div className="card-body text-center p-5">
            <h2 className="card-title fw-bold mb-4" style={{ color: "var(--heading)" }}>
              Ready to Plan Smarter?
            </h2>

            <p className="card-text mb-4" style={{ color: "var(--text)", lineHeight: "1.7" }}>
              Whether you’re a salaried professional, a business owner, or navigating a career change — your financial well-being deserves expert attention. We’re here to listen, guide, and walk the journey with you.
            </p>

            <div className="mb-4">
              <p className="mb-2">
                <span role="img" aria-label="email">📧</span> Email: <a href="mailto:contact@sagfinancials.com" className="text-decoration-none "style={{color:"var(--secondary)"}}>contact@sagfinancials.com</a>
              </p>
              <p className="mb-2">
                <span role="img" aria-label="phone">📱</span> Call / WhatsApp: <a href="tel:+917011468336" className="text-decoration-none "style={{color:"var(--secondary)"}}>+91 7011468336</a>
              </p>
              <p className="mb-2">
                <span role="img" aria-label="website">🌐</span> Visit: <a href="https://sagfinancials.dynode.in" target="_blank" rel="noopener noreferrer" className="text-decoration-none " style={{color:"var(--secondary)"}}>sagfinancials.com</a>
              </p>
              <p className="mb-0">
                <span role="img" aria-label="location">📍</span> Serving clients across India | 100% digital financial services
              </p>
            </div>

            <Link 
              to="/contact" 
              className="btn  btn-lg rounded-pill"
              style={{background: "var(--primary)", color: "var(--white)", border: "none"}}
            >
              Schedule a Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyToPlan;
